import {
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ReactComponent as ScheduleSvg } from "assets/Svgs/Schedule.svg";
import { ReactComponent as UserSvg } from "assets/Svgs/UserSvg.svg";
import { ReactComponent as HistorySmallSvg } from "assets/Svgs/HistorySmall.svg";

import { ReactComponent as EditSvg } from "assets/Svgs/Edit.svg";
import i18n from "i18n/i18n";
import NotificationAttachments from "components/NotificationAttachments";
import { getProgressStatus } from "shared-functions/notification";
import moment from "moment";
import { useBoundStore } from "store/store";
import IconText from "components/IconText";
import { Link } from "react-router-dom";
function OverviewTab(props: any) {
  const lang: any = useBoundStore((state) => state.lang);

  let notificationData = props.notificationData;

  const updateNotification = useBoundStore((state) => state.updateNotification);
  const isLoggedIn = useBoundStore((state) => state.isLoggedIn);

  const [status, setStatus] = useState("");
  const [notificationnodeid, setNotificationNodeId] = useState();
  const loadTopology: any = useBoundStore((state) => state.loadTopology);

  let dropdownSolutionStatus = [
    { title: "Offen", value: "0" },
    { title: "In Bearbeitung", value: "1" },
    { title: "Erledigt", value: "2" },
  ];

  useEffect(() => {
    setNotificationNodeId(notificationData?.nodeid);
    setStatus(notificationData?.status.toString());
  }, [notificationData]);

  return (
    <div className="overviewTab">
      {notificationData?.type != 6 ? (
        <>
          <div className="innerDetail">
            <div className="selectBox">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  {i18n(lang)?.status}
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={status}
                  label={i18n(lang)?.status}
                  onChange={(e) => handleSolutionStatusClicks(e.target.value)}
                >
                  {dropdownSolutionStatus.map((status) => (
                    <MenuItem key={status.value} value={status.value}>
                      {status.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            <Grid
              xs={9}
              sx={{ paddingLeft: "24px" }}
              className={"notificationDetailsContainer"}
            >
              <ul
                className="iconTextList"
                
              >
                <li>
                  <IconText
                    icon={<HistorySmallSvg style={{ marginLeft: "3px" }} />}
                    text={
                      <span
                        style={{ cursor: "pointer" }}
                        className="smallCaption"
                      >
                        <Tooltip
                          title={
                            i18n(lang)?.reported +
                            ": " +
                            moment(notificationData?.created).format(
                              "DD.MM.YY"
                            ) +
                            ", " +
                            moment(notificationData?.created).format("hh:mm") +
                            i18n(lang).clock +
                            notificationData?.hasauthor[0]?.user?.givenname +
                            " " +
                            notificationData?.hasauthor[0]?.user?.surname
                          }
                        >
                          <div>
                            {i18n(lang)?.reported + ": "}

                            <span
                              style={{
                                borderBottomStyle: "dotted",
                                borderBottomWidth: "1px",
                              }}
                            >
                              {moment(notificationData?.created).format(
                                "DD.MM.YY"
                              )}
                            </span>
                          </div>
                        </Tooltip>
                      </span>
                    }
                  />
                </li>
                {+notificationData?.status === 2 ? (
                  <li>
                    <Grid
                      xs={9}
                      className={"notificationDetailsContainer"}
                      style={{ margin: "9px 0px 0px 0px", padding: 0 }}
                    >
                      <Grid
                        xs={12}
                        className={"notificationDetailsContainer"}
                        style={{ paddingLeft: 0, marginTop: -10 }}
                      >
                        <IconText
                          icon={
                            <svg
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_3687_10215"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="16"
                                height="17"
                              >
                                <rect
                                  y="0.5"
                                  width="16"
                                  height="16"
                                  fill="#D9D9D9"
                                />
                              </mask>
                              <g mask="url(#mask0_3687_10215)">
                                <path
                                  d="M9.75016 11.1834C9.87239 11.3056 10.0224 11.3667 10.2002 11.3667C10.3779 11.3667 10.5335 11.3 10.6668 11.1667C10.7891 11.0445 10.8502 10.8889 10.8502 10.7C10.8502 10.5112 10.7891 10.3556 10.6668 10.2334L8.66683 8.23337V5.81671C8.66683 5.62782 8.60305 5.47226 8.4755 5.35004C8.3475 5.22782 8.18905 5.16671 8.00016 5.16671C7.81127 5.16671 7.65305 5.23049 7.5255 5.35804C7.3975 5.48604 7.3335 5.64449 7.3335 5.83337V8.48337C7.3335 8.57226 7.35016 8.65826 7.3835 8.74137C7.41683 8.82493 7.46683 8.90004 7.5335 8.96671L9.75016 11.1834ZM8.00016 15.1667C7.07794 15.1667 6.21127 14.9916 5.40016 14.6414C4.58905 14.2916 3.8835 13.8167 3.2835 13.2167C2.6835 12.6167 2.20861 11.9112 1.85883 11.1C1.50861 10.2889 1.3335 9.42226 1.3335 8.50004C1.3335 7.57782 1.50861 6.71115 1.85883 5.90004C2.20861 5.08893 2.6835 4.38337 3.2835 3.78337C3.8835 3.18337 4.58905 2.70826 5.40016 2.35804C6.21127 2.00826 7.07794 1.83337 8.00016 1.83337C8.92239 1.83337 9.78905 2.00826 10.6002 2.35804C11.4113 2.70826 12.1168 3.18337 12.7168 3.78337C13.3168 4.38337 13.7917 5.08893 14.1415 5.90004C14.4917 6.71115 14.6668 7.57782 14.6668 8.50004C14.6668 9.42226 14.4917 10.2889 14.1415 11.1C13.7917 11.9112 13.3168 12.6167 12.7168 13.2167C12.1168 13.8167 11.4113 14.2916 10.6002 14.6414C9.78905 14.9916 8.92239 15.1667 8.00016 15.1667ZM8.00016 13.8334C9.47794 13.8334 10.7364 13.314 11.7755 12.2754C12.8142 11.2363 13.3335 9.97782 13.3335 8.50004C13.3335 7.02226 12.8142 5.76382 11.7755 4.72471C10.7364 3.68604 9.47794 3.16671 8.00016 3.16671C6.52239 3.16671 5.26416 3.68604 4.2255 4.72471C3.18638 5.76382 2.66683 7.02226 2.66683 8.50004C2.66683 9.97782 3.18638 11.2363 4.2255 12.2754C5.26416 13.314 6.52239 13.8334 8.00016 13.8334Z"
                                  fill="black"
                                  fill-opacity="0.5"
                                />
                              </g>
                            </svg>
                          }
                          text={
                            i18n(lang)?.state_closed +
                            " am: " +
                            ": " +
                            moment(notificationData?.closed).format(
                              "DD.MM.YYYY"
                            ) +
                            ", " +
                            moment(notificationData?.closed).format("hh:mm") +
                            " Uhr "
                          }
                        />

                        <IconText
                          style={{ marginLeft: "25px" }}
                          icon={
                            <svg
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_3687_13131"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="16"
                                height="17"
                              >
                                <rect
                                  y="0.5"
                                  width="16"
                                  height="16"
                                  fill="#D9D9D9"
                                />
                              </mask>
                              <g mask="url(#mask0_3687_13131)">
                                <path
                                  d="M7.99984 8.49996C7.2665 8.49996 6.63873 8.23885 6.1165 7.71663C5.59428 7.1944 5.33317 6.56663 5.33317 5.83329C5.33317 5.09996 5.59428 4.47218 6.1165 3.94996C6.63873 3.42774 7.2665 3.16663 7.99984 3.16663C8.73317 3.16663 9.36095 3.42774 9.88317 3.94996C10.4054 4.47218 10.6665 5.09996 10.6665 5.83329C10.6665 6.56663 10.4054 7.1944 9.88317 7.71663C9.36095 8.23885 8.73317 8.49996 7.99984 8.49996ZM11.9998 13.8333H3.99984C3.63317 13.8333 3.31928 13.7027 3.05817 13.4416C2.79706 13.1805 2.6665 12.8666 2.6665 12.5V11.9666C2.6665 11.5888 2.76373 11.2416 2.95817 10.925C3.15262 10.6083 3.41095 10.3666 3.73317 10.2C4.42206 9.85551 5.12206 9.59718 5.83317 9.42496C6.54428 9.25274 7.2665 9.16663 7.99984 9.16663C8.73317 9.16663 9.45539 9.25274 10.1665 9.42496C10.8776 9.59718 11.5776 9.85551 12.2665 10.2C12.5887 10.3666 12.8471 10.6083 13.0415 10.925C13.2359 11.2416 13.3332 11.5888 13.3332 11.9666V12.5C13.3332 12.8666 13.2026 13.1805 12.9415 13.4416C12.6804 13.7027 12.3665 13.8333 11.9998 13.8333ZM3.99984 12.5H11.9998V11.9666C11.9998 11.8444 11.9693 11.7333 11.9082 11.6333C11.8471 11.5333 11.7665 11.4555 11.6665 11.4C11.0665 11.1 10.4609 10.875 9.84984 10.725C9.23873 10.575 8.62206 10.5 7.99984 10.5C7.37761 10.5 6.76095 10.575 6.14984 10.725C5.53873 10.875 4.93317 11.1 4.33317 11.4C4.23317 11.4555 4.15261 11.5333 4.0915 11.6333C4.03039 11.7333 3.99984 11.8444 3.99984 11.9666V12.5ZM7.99984 7.16663C8.3665 7.16663 8.68039 7.03607 8.9415 6.77496C9.20261 6.51385 9.33317 6.19996 9.33317 5.83329C9.33317 5.46663 9.20261 5.15274 8.9415 4.89163C8.68039 4.63051 8.3665 4.49996 7.99984 4.49996C7.63317 4.49996 7.31928 4.63051 7.05817 4.89163C6.79706 5.15274 6.6665 5.46663 6.6665 5.83329C6.6665 6.19996 6.79706 6.51385 7.05817 6.77496C7.31928 7.03607 7.63317 7.16663 7.99984 7.16663Z"
                                  fill="black"
                                  fill-opacity="0.5"
                                />
                              </g>
                            </svg>
                          }
                          text={i18n(lang)?.state_closed + " von"}
                          right={
                            <span
                              style={{ color: "rgba(56, 116, 141, 1)" }}
                              className="smallCaption"
                            >
                              &nbsp;
                              {notificationData?.hasauthor[0]?.user?.givenname +
                                " " +
                                notificationData?.hasauthor[0]?.user?.surname}
                            </span>
                          }
                        />
                      </Grid>
                    </Grid>
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </Grid>
          </div>
          <Divider orientation="horizontal" />
        </>
      ) : (
        ""
      )}

      <div className="p24">
        <div className="generalHeading">{i18n(lang)?.message_description}</div>
        <div
          className="description"
          style={{
            maxWidth: "100%",
            wordWrap: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          {
          // notificationData?.type == 6
          //   ? notificationData?.hasworkflow &&
          //     notificationData?.hasworkflow[0]?.workflow?.hasworkflowstep[0]
          //       .workflowstep.description
          //   :
             notificationData?.description
            }
        </div>
        <NotificationAttachments
          notificationData={notificationData}
          from="overview"
          workflowAttachments={
            notificationData?.notification?.hasworkflow &&
            notificationData?.notification?.hasworkflow[0]?.workflow
              ?.hasworkflowstep &&
              notificationData?.notification?.hasworkflow[0]?.workflow
              ?.hasworkflowstep[0].workflowstep.hasattachment
          }
        />
      </div>

      <Divider orientation="horizontal" />

      <div className="p24">
        <div className="flex">
          <div>
            <Link
              to="/edit-notification"
              state={{
                notificationData: notificationData,
                isEditMode: true,
              }}
            >
              <Button variant="outlined" startIcon={<EditSvg />}>
                {i18n(lang)?.update_notification}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  async function handleSolutionStatusClicks(value: any) {
    setStatus(value);
    const onlyStatusUpdate = true;
    const nodeid = notificationData?.nodeid;
    const status = parseInt(value);
    const previousStatus = Number(notificationData?.status);
    const equipmentnodeid =
      notificationData?.isnotificationof[0]?.equipment.nodeid;
    let payload = {};

    //open > in progress: set status and progressstarted TS
    if (previousStatus == 0 && status == 1) {
      const progressstarted = Date.now();
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        progressstarted,
        equipmentnodeid,
      };
    }
    //open > closed: set status, set progressstarted and closed to same TS
    else if (previousStatus == 0 && status == 2) {
      const progressstarted = Date.now();
      const closed = Date.now();
      const closedMom = moment(Date.now());
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        progressstarted,
        closed,
        equipmentnodeid,
      };
      let timeDifference = closedMom.diff(notificationData?.created);

      // if time longer than 48h, show time range as days
      if (timeDifference < 172800000) {
        timeDifference = closedMom.diff(notificationData?.created, "hours");
      } else {
        timeDifference = closedMom.diff(notificationData?.created, "days");
      }
      
    }
    //in progress > closed: set status and closed TS
    else if (previousStatus == 1 && status == 2) {
      const progressstarted = Date.now();
      const closed = Date.now();
      const closedMom = moment(Date.now());
      payload = {
        nodeid,
        status,
        progressstarted,
        previousStatus,
        onlyStatusUpdate,
        closed,
        equipmentnodeid,
      };
      let timeDifference = closedMom.diff(notificationData?.created);
      // if time longer than 48h, show time range as days
      if (timeDifference < 172800000) {
        timeDifference = closedMom.diff(notificationData?.created, "hours");
      } else {
        timeDifference = closedMom.diff(notificationData?.created, "days");
      }
      
    }

    //in progress > open: set status, set progrssstarted to 0
    else if (previousStatus == 1 && status == 0) {
      const progressstarted = 0;
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        progressstarted,
        equipmentnodeid,
      };
    }

    //closed > in progress: set status, set closed to 0
    else if (previousStatus == 2 && status == 1) {
      const closed = 0;
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        closed,
        equipmentnodeid,
      };
    }
    //closed > open: set status, set closed to 0, set progressstarted to 0
    else if (previousStatus == 2 && status == 0) {
      const progressstarted = 0;
      const closed = 0;
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        progressstarted,
        closed,
        equipmentnodeid,
      };
    }

    const promises = await updateNotification(payload);
    if (isLoggedIn === true) {
      try {
        const result = await Promise.all(promises);
        setTimeout(() => {
          loadTopology(lang);
        }, 1500);
      } catch (error) {
        console.error("Error during promise execution:", error);
      }
    }
  }
}

export default OverviewTab;
